import { Typography, Modal, 
} from '@mui/material';
import Box from '@mui/material/Box';
import React, { useState, useEffect } from 'react';
import AxiosFetchData from '../pages/AxiosFetchData';
import jwt_decode from 'jwt-decode';
import { useNavigate} from 'react-router-dom';
import { styled } from '@mui/material/styles';
 import Chip from '@mui/material/Chip';
 import Paper from '@mui/material/Paper';
  
const   UserDialog = ({showDialog, handleClose, idstatus, handleName, handleMessage }) => {
    const [idStatus, setIdStatus] = useState('');
    const [chipData, setChipData] = React.useState([]);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [role, setRole] = useState('');
    const [selectedRoles, setSelectedRoles] = useState('');
    const [userName, setUserName] = useState('');
    const Navigate = useNavigate();
    //const [message, setmessage] = useState('');

    useEffect(() => {
        GetUser();
    }, []);

      const GetUser = async () => {
        try{
          const decoded = jwt_decode(localStorage.getItem('token'));
          const response = await AxiosFetchData.get(`GetUsersById/${decoded.userID}/${decoded.role}`).refreshToken(Navigate);
         
          if(response.data.length > 0){
            setName(response.data[0].nama_client);
            setUserName(response.data[0].nama_client);
            setEmail(response.data[0].email);
            setSelectedRoles(response.data[0].name);
            setIdStatus(decoded.userID)
         
            handleName(response.data[0].nama_client);
 
            return;
          }

          handleName(decoded.name);
        }catch{
         
        }
      }

      async function AddStatus(e){
        e.preventDefault(); 
        
        try{
           
           if(idstatus){
              
            var data = {
              id: idStatus,
              name : name,
              email : email,
              password :  password,
              confirmpassword :  confirmPassword,
          
            }
            var response = await AxiosFetchData.post(`UpdateUser`, data).refreshToken(Navigate)
            if(response){
                handleMessage("Data updated successfully");
                handleClose();
            }
          }else{
            var data = {
              name : name,
              email : email,
              password :  password,
              confirmpassword :  confirmPassword,
              role : selectedRoles
            }
           
            var response = await AxiosFetchData.post(`Register`, data).refreshToken(Navigate)
      
            if(response){
              handleClose();
            }
          }
           await GetUser();
        }catch(e){
           handleMessage(e.message);
        }
          
      }

      const ListItem = styled('li')(({ theme }) => ({
        margin: theme.spacing(0.5),
      }));
    return(
        <div>
        <Modal
        open={showDialog}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className='modals-delegasi' >
       
          <Typography id="modal-modal-description">
            <form onSubmit={AddStatus} role="form">
            <div class="row">
            <div class="col-md-12">
            <label>Name</label>
            <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
            </div>
             </div>
             <div class="row">
            <div class="col-md-12">
            <label>Email</label>
            <input
                      type="text"
                      className="form-control"
                      placeholder="Email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
            </div>
             </div>
             {idStatus && (
             <div class="row">
            <div class="col-md-12">
                
            <label>Current Password</label>
            <input
                      type="text"
                      className="form-control"
                      placeholder="Password"
                      required
                      value="*****"
                     // onChange={(e) => setPassword(e.target.value)}
                     readOnly
                    />
            </div>
             </div>
             )}
             <div class="row">
            <div class="col-md-12">
            <label>{idStatus && "New"} Password</label>
            <input
                      type="password"
                      className="form-control"
                      placeholder="New Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
            </div>
             </div>
           
             <div class="row">
            <div class="col-md-12">
            <label>Confirm Password</label>
            <input
                      type="password"
                      className="form-control"
                      placeholder="Confirm Password"
                       
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
            </div>
             </div>
             
             <div class="row">
            <div class="col-md-12">
            <label>Role</label>
            <input
                      type="input"
                      className="form-control"
                      placeholder="Roles"
                       disabled={true}
                      value={selectedRoles}
                      onChange={(e) => setSelectedRoles(e.target.value)}
                    />
            </div>
             </div>
             
             
         <hr></hr>
         <div class="row">
            <div class="col-md-12" style={{textAlign:'right'}}>
            <div style={{marginTop:5,marginBottom:5}}>
            <button type="submit" className="btn btn-primary">{idstatus ? "UPDATE" : "ADD"}</button>
                 </div>
            </div>
           
         </div>
         </form>
         
          </Typography>
        </Box>
</Modal>
{/* <ResponseDialog message={message} setmessage={setmessage}></ResponseDialog> */}
</div>
    )
}

export default UserDialog;